import EzModalController from 'layouts/modal/modal-controller';
import events from 'lib/events';

import { showHideItems } from 'lib/helpers';
import { sanitizeTerm } from 'lib/search-helpers';
import FuzzySet from 'fuzzyset.js';

export default class CollectionsModalController extends EzModalController {
  static targets = [
    'collectionsList',
    'collectionsListItem',
    'saveButton',
  ];

  connect() {
    super.connect();

    this.compileCollectionsList();

    this.searchForm = document.querySelector('[data-controller="collections-search-form"]');

    this.searchForm.addEventListener(events.collections.search_collections, this.searchCollections);
  }

  disconnect() {
    this.searchForm.removeEventListener(events.collections.search_collections, this.searchCollections);

    super.disconnect();
  }

  compileCollectionsList() {
    const collections = document.getElementsByClassName('collections-list__item__name');

    this.collectionsListArr = [...collections].map(
      (collection) => sanitizeTerm(collection.textContent) || sanitizeTerm(collection.innerText),
    );

    this.fuzzySearch = FuzzySet(this.collectionsListArr, false);
  }

  searchCollections = (event) => {
    if (sanitizeTerm(event.target.value).length) {
      this.saveButtonTarget.classList.remove('is-disabled');
    } else {
      this.saveButtonTarget.classList.add('is-disabled');
    }

    this.filterCollections(sanitizeTerm(event.target.value));
  }

  filterCollections(search) {
    const results = this.fuzzySearch.get(search, null, 0.2);

    showHideItems(this.collectionsListItemTargets, 'show', 'flex');

    if (search) showHideItems(this.collectionsListItemTargets, 'hide');

    if (results) {
      results.forEach((result) => {
        const collectionName = sanitizeTerm(result[1]);
        const matchingEls = this.collectionsListTarget.querySelectorAll(`[data-collection-name*="${collectionName}"]`);

        if (matchingEls) {
          showHideItems(matchingEls, 'show', 'flex');
        }
      });
    }
  }
}
